module.exports = __webpack_public_path__ + "img/sprite.symbol.60344c51.svg";